// Where the browser sends its own API calls. Production builds set
// VITE_API_FETCH_URL=/api/v1: the dashboard's origin proxies it to the worker
// (functions/api), because some networks cannot reach *.workers.dev.
// VITE_API_URL stays the worker's public address for URLs shown to people
// outside (API docs, postback links, media).
export const API_FETCH_URL: string =
  import.meta.env.VITE_API_FETCH_URL || import.meta.env.VITE_API_URL || '/api/v1';
